import {
  MONITOR_TYPE_LOAD,
  MONITOR_TYPE_LOAD_SUCCESS,
  MONITOR_TYPE_ERROR,
  MONITOR_TYPE_CLEAN,
} from "./actionTypes"

const initialState = {
  error: "",
  types: [],
  loading: false,
  current: null,
  types_messages: [],
}

const typeMonitor = (state = initialState, action) => {
  switch (action.type) {
    case MONITOR_TYPE_LOAD:
      state = {
        ...state,
        types: [],
        loading: true,
        error: "",
      }
      break
    case MONITOR_TYPE_LOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        types: action.payload,
        current: action.payload.length === 1 ? action.payload[0] : null,
      }
      break
    case MONITOR_TYPE_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        current: null,
      }
      break

    case MONITOR_TYPE_CLEAN:
      state = {
        ...state,
        loading: false,
        error: "",
      }
      break
  }
  return state
}

export default typeMonitor
